import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/common/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" path="/404" />
      <section className="grid min-h-[70vh] place-items-center px-5 py-24 text-center">
        <div>
          <p className="font-display text-[22vw] font-semibold leading-none tracking-tight text-primary/10 sm:text-[12rem]">404</p>
          <h1 className="-mt-8 font-display text-3xl font-medium tracking-tight sm:text-4xl">This page went off-grid</h1>
          <p className="mx-auto mt-4 max-w-md text-muted-foreground">The page you&apos;re looking for doesn&apos;t exist or has moved. Let&apos;s get you back on track.</p>
          <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-transform hover:-translate-y-0.5" data-testid="notfound-home">
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </div>
      </section>
    </>
  );
}
